export default "__VITE_ASSET__3d4c2a3f__"